{
    "columns": [
        {
            "header_id": "tasBillingReconFileMasterId",
            "header_label": "Recon File Id",
            "jsonpath": "tasBillingReconFileMasterId",
            "isDisplayedAtHeader": "y",
            "isSearchable": "y"
        },
        {
            "header_id": "pplIcn",
            "header_label": "PPL ICN",
            "jsonpath": "pplIcn",
            "isDisplayedAtHeader": "y",
            "isSearchable": "y"
        },
        {
            "header_id": "lineItemControlNumber",
            "header_label": "Batch Id",
            "jsonpath": "lineItemControlNumber",
            "isDisplayedAtHeader": "y",
            "isSearchable": "n"
        },
        {
            "header_id": "patientName",
            "header_label": "Patient Name",
            "jsonpath": "patientName",
            "isDisplayedAtHeader": "y",
            "isSearchable": "y"
        },
        {
            "header_id": "carcReasonCode",
            "header_label": "CARC",
            "jsonpath": "carcReasonCode",
            "isDisplayedAtHeader": "y",
            "isSearchable": "y"
        },
        {
            "header_id": "rarcReasonCode",
            "header_label": "RARC",
            "jsonpath": "rarcReasonCode",
            "isDisplayedAtHeader": "y",
            "isSearchable": "y"
        },
        {
            "header_id": "serviceDate",
            "header_label": "Service Date",
            "jsonpath": "serviceDate",
            "isDisplayedAtHeader": "y",
            "isSearchable": "y"
        },
        {
            "header_id": "payerName",
            "header_label": "MCO Name",
            "jsonpath": "payerName",
            "isDisplayedAtHeader": "y",
            "isSearchable": "y"
        },
        {
            "header_id": "paymentNumber",
            "header_label": "Payment Number",
            "jsonpath": "paymentNumber",
            "isDisplayedAtHeader": "y",
            "isSearchable": "y"
        },
        {
            "header_id": "paymentAmount",
            "header_label": "Check Amount",
            "jsonpath": "paymentAmount",
            "isDisplayedAtHeader": "y",
            "isSearchable": "y"
        },
        {
            "header_id": "paymentDate",
            "header_label": "Payment Date",
            "jsonpath": "paymentDate",
            "isDisplayedAtHeader": "y",
            "isSearchable": "y"
        },
        {
            "header_id": "patientPaidAmount",
            "header_label": "Paid Amount",
            "jsonpath": "patientPaidAmount",
            "isDisplayedAtHeader": "y",
            "isSearchable": "y"
        },
        {
            "header_id": "externalIcn",
            "header_label": "External ICN",
            "jsonpath": "externalIcn",
            "isDisplayedAtHeader": "y",
            "isSearchable": "y"
        },
        {
            "header_id": "paymentClaimStatus",
            "header_label": "Claim Status",
            "jsonpath": "paymentClaimStatus",
            "isDisplayedAtHeader": "y",
            "isSearchable": "y"
        },
        {
            "header_id": "claimStatusDescription",
            "header_label": "Claim Status Code",
            "jsonpath": "claimStatusDescription",
            "isDisplayedAtHeader": "y",
            "isSearchable": "y"
        },
        {
            "header_id": "createddate",
            "header_label": "Created Date",
            "jsonpath": "createddate",
            "isDisplayedAtHeader": "n",
            "isSearchable": "n"
        }
    ],
    "buttons": [],
    "apiDetails": "files.json",
    "pageName": "billingPaymentFileDetailListView",
    "orderByColumn": ["paymentDate"],
    "orderBy": ["desc"]
}